import React from 'react'

const TestimonialsBannerSection = () => {
    return (
        <>
            <section className="bannerSec innerBanner">
                <div className="box-position" style={{background: 'url("/images/innerBanner.jpg")'}}>

                </div>
                <div className="bannerTxt">
                    <h1>Testimonial</h1>
                </div>
            </section>
        </>
    )
}

export default TestimonialsBannerSection